
      import GoBack from './go-back.vue'
      import type { App, Plugin } from 'vue'

      export const GoBackPlugin: Plugin = {
        install(app: App) {
          app.component('GoBack', GoBack)
        },
      }
      export { GoBack }
      